import React, { useState } from "react";
import "./Login.scss";
import coins from "../../assets/Images/CryptooAntsLoginImage.svg";
import { serverAddr } from "./../../networkConfig";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function Login() {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!username.trim()) {
      setError("Username is required");
      return;
    }

    if (!password.trim()) {
      setError("Password is required");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const data = await serverAddr.post("auth/login/", {
        username: username,
        password: password
      });

      if (data.access) {
        localStorage.setItem("token", data.access);
      }

      if (data.refresh) {
        localStorage.setItem("refresh_token", data.refresh);
      }

      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
      }

      toast.success("Login Successful!");
      navigate("/publisher", { replace: true });

    } catch (err) {
      setError(err?.detail || err?.message || "Invalid username or password");
    }

    setLoading(false);
  };


  return (
    <>
    <div className="auth-wrapper">

      {/* LEFT SIDE IMAGE */}
      <div className="auth-left">
        <img src={coins} alt="crypto coins" />
      </div>

      {/* RIGHT SIDE CARD */}
      <div className="auth-right">
        <div className="auth-card">

          <div className="brand">
            <img
              src={require("../../assets/Logos/Cryptoants.png")}
              alt="Logo"
              className="logo-img"
            />
            <h3>Login</h3>
          </div>

          <form onSubmit={handleSubmit}>

            {/* USERNAME */}
            <input
              type="text"
              placeholder="Username / Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            {/* PASSWORD */}
            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <span
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </span>
            </div>

            {/* ERROR MESSAGE */}
            {error && <p className="error-text">{error}</p>}

            {/* BUTTON */}
            <button className="primary-btn" disabled={loading}>
              {loading ? "Signing In..." : "SIGN IN"}
            </button>

          </form>

        </div>
      </div>

    </div>

    <Toaster position="top-center" />
    </>
  );
}

export default Login;